import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bt-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  loading = false;
  constructor() { }

  ngOnInit(): void {
  }

}
